import {AddressProps, translatedAddressProps} from 'modules/addresses/types';
import React, {useState} from 'react';
import Form from 'shared/migration-components/form';
import useFormInputs from 'shared/migration-components/form/util';
import useCart from '../util/use-cart';
import useNeighborhoodsSelect from 'modules/neighborhoods/hooks/use-neighborhoods-select';
import useApi from 'shared/hooks/use-api';
import {useForm} from 'react-hook-form';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import getCurrentPosition from 'shared/util/get-current-position';

const Address: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const api = useApi();
  const {state} = useLocation();
  const formContext = useForm({defaultValues: state as any});
  const navigate = useNavigate();

  const {companyQuery, setAddress} = useCart();
  const {data: neighborhoods, isLoading} = useNeighborhoodsSelect(
    companyQuery.data?.cityId,
  );

  const [loading, setLoading] = useState(false);
  const {getInput, getSelect, getTextArea} = useFormInputs<AddressProps>();

  const handleSubmit = async (data: AddressProps) => {
    const neighborhood = neighborhoods.find(
      (neighborhood) => neighborhood.value === data.neighborhoodId,
    );

    let isError = false;

    if (!data.street) {
      formContext.setError('street', {
        message: 'Rua não informada',
      });
      isError = true;
    }

    if (!data.number) {
      formContext.setError('number', {
        message: 'Número não informado',
      });
      isError = true;
    }

    if (!neighborhood) {
      formContext.setError('neighborhoodId', {
        message: 'Bairro não informado',
      });
      isError = true;
    }

    if (isError) return;

    const search = `${data.street}, ${data.number}, ${companyQuery.data?.city.name}`;

    setLoading(true);

    const currentPosition = await getCurrentPosition();

    const response = await api({
      url: `/addresses/forward-geocoding?address=${search}`,
      method: 'GET',
      params: currentPosition,
    });

    const address = (response.data?.data ?? [])[0];

    const {latitude, longitude} = address as AddressProps;

    setAddress({
      ...data,
      city: companyQuery.data?.city.name,
      cityId: companyQuery.data?.cityId,
      neighborhood: neighborhood?.label!,
      latitude,
      longitude,
      state: companyQuery.data?.city.state,
    });

    setLoading(false);

    if (address) navigate(id ? `/orders/${id}/cart` : '/orders/cart');
  };

  return (
    <div style={{marginTop: 15, padding: 15, paddingLeft: 10}}>
      <Form<AddressProps>
        {...{formContext}}
        inputs={[
          getInput({name: 'street'}),
          getInput({name: 'number', gridColumn: 4}),
          getSelect({
            name: 'neighborhoodId',
            data: neighborhoods,
            gridColumn: 8,
            isLoading,
          }),
          getInput({name: 'complement'}),
          getTextArea({name: 'reference'}),
        ]}
        translationKey={translatedAddressProps}
        extraButtons={(data) => [
          {title: 'SALVAR', onClick: () => handleSubmit(data), loading},
        ]}
      />
    </div>
  );
};

export default Address;
